import { api } from '../../core/api.js';
import { html } from '../../core/html.js';
import { fmtDateTime, fmtWhen as when, firstName } from '../../core/format.js';
import { session } from '../../core/session.js';
import { bar, empty, ic, pageHead, stat, tag } from '../../ui/components.js';
import { resumeBanner } from '../resume/card.js';

export const dashboard = {
  path: '/student/dashboard',
  roles: ['student'],
  title: 'Dashboard',
  load: async (ctx) => {
    const [d, opportunities, resume] = await Promise.all([
      api.get('/student/dashboard', { signal: ctx.signal }),
      api.get('/student/opportunities', { signal: ctx.signal }).catch(() => ({ opportunities: [] })),
      api.get('/resumes/mine', { signal: ctx.signal }).catch(() => null),
    ]);
    return { ...d, resume, matches: opportunities.opportunities.filter((o) => o.eligibility?.eligible && !o.interest).slice(0, 2) };
  },
  view(d) {
    const next = d.next_class;
    const done = d.enrollments.reduce((n, e) => n + (e.progress?.assignments_done || 0), 0);
    const certs = d.enrollments.filter((e) => e.progress?.final_passed).length;
    return html`${pageHead(`Welcome back, ${firstName(session.user.name)}`,
      next ? `Next class: ${next.course}, class ${next.number}, ${when(next.starts_at)}.` : 'No class is scheduled yet.',
      next ? html`<a class="btn" href="/student/classes/${next.id}">${ic('play')} ${next.state === 'live' ? 'Join the live class' : 'Open class'}</a>` : html`<a class="btn" href="/student/learn">Find a course</a>`)}
      ${resumeBanner(d.resume)}
      <div class="grid stats">${stat(`${d.profile_strength.percent}%`, 'Profile complete')}
        ${stat(d.assessment_avg == null ? '–' : `${Math.round(d.assessment_avg)}%`, 'Assessment average')}
        ${stat(done, 'Assignments done')}${stat(certs, 'Certificates')}</div>
      <div class="grid g2 mt">
        <div class="card"><div class="row between"><h3 style="margin:0">Continue learning</h3><a class="sm" href="/student/learn">All courses</a></div>
          ${d.enrollments.length
            ? d.enrollments.map((e) => html`<div class="mt-s"><div class="row between sm"><b>${e.course.title}</b><span class="mu">${e.progress?.percent ?? 0}%</span></div>${bar(e.progress?.percent ?? 0, '', e.course.title)}
              ${e.has_access ? '' : html`<p class="xs mt-s">${tag('Access ended', 'wn')} <a href="/student/course/${e.course.slug}">Renew</a></p>`}</div>`)
            : html`<p class="mu">No courses yet. <a href="/student/learn">Pick a live batch</a>.</p>`}</div>
        <div class="card"><h3>Coming up</h3><div class="list sm">
          ${next ? html`<div class="li">${ic('play')}<span class="f1"><b>${when(next.starts_at)}</b><br>${next.course}, class ${next.number}</span><a class="btn sm" href="/student/classes/${next.id}">${next.state === 'live' ? 'Join' : 'Open'}</a></div>` : ''}
          ${d.assignments_due.map((a) => html`<div class="li">${ic('clip')}<span class="f1"><b>Due ${fmtDateTime(a.due_at)}</b><br>${a.title}</span><a class="btn ghost sm" href="/student/assignments/${a.id}">Open</a></div>`)}
          ${!next && !d.assignments_due.length ? html`<p class="mu" style="margin:0">Nothing due. Enjoy the break.</p>` : ''}</div></div>
      </div>
      <h3 class="mt">Opportunities matched to you</h3>
      ${d.matches.length
        ? html`<div class="grid g2">${d.matches.map((o) => html`<a class="card click" href="/student/opportunities"><div class="row between">${tag(o.type)}${tag('Eligible', 'ok')}</div><h4 class="mt-s">${o.title}</h4><p class="sm mu" style="margin:0">${o.org_name}${o.location ? `, ${o.location}` : ''}</p></a>`)}</div>`
        : empty('brief', 'No matches yet', 'Build skills with a course and opportunities that fit them appear here.')}`;
  },
};
